module.exports = __webpack_public_path__ + "img/itx-file-type-csv.3a8b1696.svg";